import { PageHeader } from '../../components/PageHeader';
import { VisitasTable } from './components/VisitasTable';
import { useT } from '../../locales';

export function VisitasListPage() {
  const t = useT();
  return (
    <div>
      <PageHeader title={t('pages.visitas.title')} subtitle={t('pages.visitas.subtitle')} />
      <VisitasTable />
    </div>
  );
}
